import BaseBehavior from '../../../framework/base/base';

const inputCheckboxSelector = 'input[type="checkbox"]';

class CollapsibleLinkList extends BaseBehavior {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.dom.checkboxInputs = this.element.querySelectorAll(inputCheckboxSelector);

		this.addEventListeners();
	}

	addEventListeners() {
		Array.from(this.dom.checkboxInputs).forEach(input => {
			this.addEventListener(input, 'change', e => {
				const self = e.target;

				Array.from(this.element.querySelectorAll(inputCheckboxSelector)).forEach(el => {
					if (el !== self) {
						// We can't use setAttribute, removeAttribute etc.
						// eslint-disable-next-line
						el.checked = false;
					}
				});
			});
		});
	}

	removeEventListeners() {
		Array.from(this.dom.checkboxInputs).forEach(input => {
			this.removeEventListener(input, 'change');
		});
	}

	cleanup() {
		this.removeEventListeners();
	}
}

export default CollapsibleLinkList;
